// extracted by mini-css-extract-plugin
export default {"DoublePanel":"DoublePanel-module__DoublePanel__tNys1","Label":"DoublePanel-module__Label__N+Xrr"};